import React, { useState } from "react";
import Section from "components/Section";
import Card from "components/Card";
import { Carousel } from "react-bootstrap";
import {
  CarouselCaptions,
  CarouselCaption,
  CarouselCaptionTitle,
  CarouselCaptionContent,
  CarouselContainer,
} from "./shared";

export default function WhatIsAnAudienceCard() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <CarouselContainer>
      <Section>
        <Carousel
          interval={null}
          fade
          activeIndex={index}
          onSelect={handleSelect}
        >
          <Carousel.Item>
            <CarouselCaption>
              <CarouselCaptionTitle>
                Audience as Value Neighbors
              </CarouselCaptionTitle>
              <CarouselCaptionContent>
                Audiences are groups of people defined by values—their goals and
                ideas about how the world works. We use a map of values,{" "}
                <a
                  href="https://en.wikipedia.org/wiki/Theory_of_Basic_Human_Values"
                  target="_blank"
                >
                  based on the work of social scientist Shalom Schwartz
                </a>
                , where position matters. Tough Cookies are more like Don’t
                Tread on Me than If You Say So, since the core values of both
                audiences anchor protection. We also use media engagement habits
                and attitudes toward specific issues to further define our
                audiences. Demography offers an additional descriptive layer.
              </CarouselCaptionContent>
            </CarouselCaption>
          </Carousel.Item>
          <Carousel.Item>
            <CarouselCaption>
              <CarouselCaptionTitle>
                Audience and Media Consumption
              </CarouselCaptionTitle>
              <CarouselCaptionContent>
                A group of people may share attitudes about an issue or
                demographic traits and yet occupy radically different cultural
                spaces in terms of the genres, platforms, voices, or stories
                they spend time on. Reaching them means understanding and adding
                value to their cultural milieu. We’ve found that values are the
                best predictor of cultural affinity. And, combined with survey,
                our behavioral media consumption data allow us to always refine our
                audience models.
              </CarouselCaptionContent>
            </CarouselCaption>
          </Carousel.Item>
          <Carousel.Item>
            <CarouselCaption>
              <CarouselCaptionTitle>
                Audience-forward Strategy
              </CarouselCaptionTitle>
              <CarouselCaptionContent>
                Audiences can tell us to what extent people encounter an issue,
                narrative, or type of content, like disinformation,
                in their media intake. They can help us to
                better understand vulnerabilities, opportunities, and risks, and
                to form hypotheses for narrative intervention. So, by the time
                we’re ready to produce content, we know whom we should be
                speaking to, how, and where.
              </CarouselCaptionContent>
            </CarouselCaption>
          </Carousel.Item>
        </Carousel>
        <div className="pt-4">
          <Carousel
            interval={null}
            fade
            activeIndex={index}
            controls={false}
            indicators={false}
          >
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="/images/what-is-an-audience/what-is-an-audience-1.png"
                alt="First slide"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="/images/what-is-an-audience/what-is-an-audience-2.png"
                alt="Second slide"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="/images/what-is-an-audience/what-is-an-audience-3.png"
                alt="Third slide"
              />
            </Carousel.Item>
          </Carousel>
        </div>
      </Section>
    </CarouselContainer>
  );
}
